import gql from 'graphql-tag';
import { createUseQueryHook } from '@jupiterone/jupiter-web-toolkit';

export interface SlackIntegrationInstance {
  id: string;
  name: string;
}

export interface IntegrationInstancesQueryData {
  integrationInstances: {
    instances: SlackIntegrationInstance[];
  };
}

export interface IntegrationInstancesQueryVariables {
  definitionId: string;
}

export const IntegrationInstancesQuery = gql`
  query IntegrationInstances($definitionId: String) {
    integrationInstances(definitionId: $definitionId) {
      instances {
        id
        name
      }
    }
  }
`;

export const useIntegrationInstancesQuery = createUseQueryHook<
  IntegrationInstancesQueryData,
  IntegrationInstancesQueryVariables
>(IntegrationInstancesQuery);
